var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React from 'react';
import classNames from 'classnames';
import styles from './Loader.module.css';
export var GameLoader = function () {
  return (
    // <LoaderContainer fullscreen = {DeviceUtils.isPhoneOrTabletDevice()}>
    // trans_key = GAME_LOADER
    React.createElement(LoaderContainer, {
      fullscreen: false
    }, React.createElement(LoaderText, null, React.createElement(LoadingLetter, null, "L"), React.createElement(LoadingLetter, null, "O"), React.createElement(LoadingLetter, null, "A"), React.createElement(LoadingLetter, null, "D"), React.createElement(LoadingLetter, null, "I"), React.createElement(LoadingLetter, null, "N"), React.createElement(LoadingLetter, null, "G")))
  );
};
var LoaderContainer = function (_a) {
  var _b;
  var fullscreen = _a.fullscreen,
    props = __rest(_a, ["fullscreen"]);
  return React.createElement("div", __assign({
    className: classNames(styles.loaderContainer, (_b = {}, _b[styles.fullscreen] = !!fullscreen, _b))
  }, props));
};
var LoaderText = function (props) {
  return React.createElement("div", __assign({
    className: styles.loaderText
  }, props));
};
var LoadingLetter = function (props) {
  return React.createElement("span", __assign({
    className: styles.loadingLetter
  }, props));
};